// extracted by mini-css-extract-plugin
export var heading = "comments-module--heading--f1d5e";
export var headingText = "comments-module--heading-text--d5299";